import { AppConfiguration } from '../../common/helpers/app-configuration';

const appSiteConfig = AppConfiguration.Setting();

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const MsalConfig = {
  auth: {
    authority: appSiteConfig.iniAuthority,
    clientId: appSiteConfig.iniAppClientID,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox
  }
};

//this needs to be read from config and used in loginrequest and will need to be added to GMatrix Edtor Web azure app instance if it isnt there
export const loginRequest = {
  /*scopes: ["api://a805db6a-32da-4c7e-bb26-e0475e1f4cb7/GME.ReadWrite"],*/
  scopes: [appSiteConfig.scopes],
};